module.exports = __webpack_public_path__ + "img/browse-vehicles-three-tabs-chevy.5878d58f.png";